<template>
  <div>
    <select class="form-control" @change="select($event.target.value)">
      <option :value="null">{{ $t("all_strategies") }}</option>
      <option
        v-for="portfolio in portfolios"
        :key="portfolio.id"
        :value="portfolio.id"
      >
        {{ portfolio.name }}
      </option>
    </select>
  </div>
</template>

<script>
export default {
  name: "TransactionsStrategyPicker",
  props: {
    showAllButton: {
      type: Boolean,
      required: false,
      default: true
    },
    showDeleteButton: {
      type: Boolean,
      required: false,
      default: false
    }
  },
  computed: {
    portfolios() {
      return this.$store.state.portfolio.items;
    },
    currentPortfolio() {
      return this.$store.state.portfolio.selected;
    }
  },
  methods: {
    select(data) {
      this.$store.commit("portfolio/select", data);
      this.$emit("selected", data);
    }
  }
};
</script>

<style lang="scss">
.portfolio-buttons {
  .btn:not(.btn-warning) {
    //border-radius: 8px;
    border: 1px solid gray;
    background-color: $dark-gray;
    color: #fff !important;
    line-height: 120%;
    font-size: 13px;
    padding: 5px 15px;
    box-shadow: none;
    outline: none;
    margin-right: 10px;
    margin-bottom: 10px;
    text-align: left;
    position: relative;

    &.delete-mode {
      padding-right: 35px;
    }

    &.active {
      border: 2px solid gray;
    }

    strong {
      display: block;
    }

    span {
      color: #bbb;
    }

    .btn-delete {
      position: absolute;
      right: 10px;
      top: 50%;
      margin-top: -8px;
    }
  }

  .transactions-type-picker,
  .transactions-date-picker {
    .btn-sm {
      height: 28px !important;

      @include media-breakpoint-down(md) {
        height: 40px !important;
      }
    }
  }
}
</style>
